import React from 'react';

function FooterBar({ version, buildId }) {
  return (
    <footer className="app-footer">
      <div className="footer-links">
        <a href="/privacy.html" target="_blank" rel="noreferrer">Privacy Policy</a>
        <a href="/terms.html" target="_blank" rel="noreferrer">Terms of Service</a>
      </div>
      <div className="footer-note">© {new Date().getFullYear()} Fitness Journey • fitnessjounrey.vip • Ver. {version} • Build {buildId}</div>
    </footer>
  );
}

export default FooterBar;
